/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from "@angular/common/http";
import { CoreModule } from "./@core/core.module";
import { ThemeModule } from "./@theme/theme.module";
import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import {
  NbAlertModule,
  NbCardModule,
  NbChatModule,
  NbCheckboxModule,
  NbContextMenuModule,
  NbDatepickerModule,
  NbDialogModule,
  NbFormFieldModule,
  NbIconModule,
  NbLayoutModule,
  NbMenuModule,
  NbSelectModule,
  NbSidebarModule,
  NbStepperModule,
  NbTabsetModule,
  NbToastrModule,
  NbToggleModule,
  NbWindowModule,

} from "@nebular/theme";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { LoginComponent } from "./auth/login/login.component";
import { RegisterComponent } from "./auth/register/register.component";
import { ForgotComponent } from "./auth/forgot/forgot.component";
import { AxiosServicesService } from "./services/axios/axios-services.service";
import { BaseHttpClientAxiosService } from "./services/axios/base-http-client-axios.service";
import { Ng2SmartTableModule } from "ng2-smart-table";
import { AdminUserComponent } from "./admin/admin-user/admin-user.component";
import { RolesComponent } from "./admin/user-management/roles/roles.component";
import { AddRolesComponent } from "./admin/user-management/roles/add-roles/add-roles.component";
import { StartupsComponent } from "./admin/startups/startups.component";
import { DashboardComponent } from "./admin/dashboard/dashboard.component";
import { PermissionComponent } from "./admin/permission/permission.component";
import { RoleService } from "./services/role.service";
import { NotFoundComponent } from "./@core/miscellaneous/not-found/not-found.component";
import { ToastrComponent } from "./@core/miscellaneous/toastr/toastr.component";
import { DialogComponent } from "./@core/miscellaneous/dialog/dialog.component";
import { DialogNamePromptComponent } from "./@core/miscellaneous/dialog/dialog-name-prompt/dialog-name-prompt.component";
import { ShowcaseDialogComponent } from "./@core/miscellaneous/dialog/showcase-dialog/showcase-dialog.component";
import { MentorComponent } from "./admin/mentor/mentor.component";
import { IncubatorComponent } from "./admin/incubator/incubator.component";
import { InvestorComponent } from "./admin/investor/investor.component";
import { CoeComponent } from "./admin/coe/coe.component";
import { AcceleratorComponent } from "./admin/accelerator/accelerator.component";
import { ViewChallengeComponent } from "./admin/challenges/view-challenge/view-challenge.component";
import { AddChallengeComponent } from "./admin/challenges/add-challenge/add-challenge.component";
import { FormsComponent } from "./admin/challenges/forms/forms.component";
import { EditionComponent } from "./admin/challenges/edition/edition.component";
import { AngularEditorModule } from "@kolkov/angular-editor";
import { RoundsComponent } from "./admin/challenges/rounds/rounds.component";
import { ResetpasswordComponent } from "./auth/resetpassword/resetpassword.component";
import { NewsComponent } from "./admin/news/news.component";
import { FaqsComponent } from "./admin/faqs/faqs.component";
import { PressReleaseComponent } from "./admin/press-release/press-release.component";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { MatButtonModule } from "@angular/material/button";
import { MediaComponent } from "./admin/media/media.component";
import { CKEditorModule } from "@ckeditor/ckeditor5-angular";
import { LabFacilitiesModule } from "./admin/lab-facilities/lab-facilities.module";
import { NgSelectModule } from "@ng-select/ng-select";
import { EvaluatorloginComponent } from "./auth/evaluatorlogin/evaluatorlogin.component";
import { EvaluatorchangepasswordComponent } from "./auth/evaluatorchangepassword/evaluatorchangepassword.component";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { NgxPaginationModule } from "ngx-pagination";
import { GrantManagementModule } from "./admin/grant-management/grant-management.module";
import { LabFacilitiesStatusComponent } from "./admin/labs-facilties-status/labs-facilties-status.component";
import { MatDialogModule } from '@angular/material/dialog';
import {MatMenuModule} from '@angular/material/menu';
import { IndividualincubatorComponent } from "./admin/individualincubator/individualincubator.component";
import { AssignStartupComponent } from "./admin/assign-startup/assign-startup.component";
import { LoaderInterceptor } from "./admin/loader.interceptor";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MediagalleryComponent } from './admin/mediagallery/mediagallery.component';
import { MentorformsComponent } from "./admin/mentor/mentorforms/mentorforms.component";
import { MentorformpreviewComponent } from './admin/mentorformpreview/mentorformpreview.component';
import { MentorformsallComponent } from './admin/mentorformsall/mentorformsall.component';
import { IndividualmentorComponent } from './admin/mentorformsall/individualmentor/individualmentor.component';
import { CustomdatePipe } from './customdate.pipe';
import { TeamsComponent } from './admin/teams/teams/teams.component';
import { SharedModule } from "./shared/shared.module";
//import { PaginationComponent } from './admin/pagination/pagination.component';


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    RegisterComponent,
    ForgotComponent,
    RolesComponent,
    AddRolesComponent,
    StartupsComponent,
    DashboardComponent,
    PermissionComponent,
    AdminUserComponent,
    ToastrComponent,
    DialogComponent,
    DialogNamePromptComponent,
    ShowcaseDialogComponent,
    MentorComponent,
    IncubatorComponent,
    InvestorComponent,
    CoeComponent,
    AcceleratorComponent,
    AddChallengeComponent,
    ViewChallengeComponent,
    NotFoundComponent,
    FormsComponent,
    EditionComponent,
    RoundsComponent,
    ResetpasswordComponent,
    NewsComponent,
    FaqsComponent,
    PressReleaseComponent,
    MediaComponent,
    EvaluatorloginComponent,
    EvaluatorchangepasswordComponent,
    LabFacilitiesStatusComponent,
    IndividualincubatorComponent,
    AssignStartupComponent,
    MediagalleryComponent,
    MentorformsComponent,
    MentorformpreviewComponent,
    MentorformsallComponent,
    IndividualmentorComponent,
    CustomdatePipe,
    TeamsComponent,

    
  ],
  imports: [
    
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    NbSelectModule,
    NbIconModule,
    NbCardModule,
    NbFormFieldModule,
    NbLayoutModule,
    NbCheckboxModule,
    Ng2SmartTableModule,
    NbStepperModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: "AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY",
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    ReactiveFormsModule,
    NbAlertModule,
    NbStepperModule,
    NbContextMenuModule,
    AngularEditorModule,
    NbToggleModule,
    DragDropModule,

    MatButtonModule,
    MatDialogModule,
    MatMenuModule,
    MatTooltipModule,
    

    NbTabsetModule,
    CKEditorModule,
    LabFacilitiesModule,
    NgSelectModule,
    NgMultiSelectDropDownModule.forRoot(),
    NgxPaginationModule,
    GrantManagementModule,
    SharedModule
    
  ],
  providers: [
    AxiosServicesService,
    {
      provide: "HttpClientService", // our interface
      useClass: BaseHttpClientAxiosService, // the base class we can switch to
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true,
    },
    
    RoleService,
  ],
  exports: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
